import Entity from '../entity';
export default class AirportTerminal extends Entity<string> {
  terminal: string;
  airportId: string;
}
